var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.038,
    height: 12.152,
    viewBox: "0 0 3.038 12.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.225,8.269a1.519,1.519,0,1,0-1.519,1.519A1.523,1.523,0,0,0,18.225,8.269Zm0,9.114A1.519,1.519,0,1,0,16.706,18.9,1.523,1.523,0,0,0,18.225,17.383Zm0-4.557a1.519,1.519,0,1,0-1.519,1.519A1.523,1.523,0,0,0,18.225,12.826Z",
    transform: "translate(-15.188 -6.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.363b8b8dfd3b9697d25d396f55c94b0d.svg";
export { ForwardRef as ReactComponent };